import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useCallback } from 'react';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidateReservationGroupQuery } from '@mews-commander/core/entities';
import { formCardFactory } from '../formCardFactory';

import { getCheckedReservationIds } from '../../selectors';
import { selectionIsCancellable as selectionIsCancellableSelector } from '../../selectors/reservationModuleState/reservationSelection';
import { fetchCurrentEnterpriseCheckedReservations, fetchReservationModuleReduxEntities } from '../../actions';
import { RESERVATION_ORDER_ITEMS_EXTENT } from '../../constants';
import { ReservationCancellationForm } from './CancellationForm';

const ReservationCancellationFormCardElement = formCardFactory({
    FormElement: ReservationCancellationForm,
    titleTextKey: TextKey.Cancellation,
    dataTestId: 'reservation-cancellation-form',
});
const ReservationCancellationFormCard = ({ selectionIsCancellable, ...other }: $TSFixMe) => {
    const { scope } = other;
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const dispatch = useCommanderThunkDispatch();
    const invalidateReservations = useInvalidateReservationGroupQuery(other.scope);
    const invalidateOrderItems = useInvalidateReservationGroupQuery(other.scope, { invalidateOrderItemsQuery: true });
    const invalidateReservationData = useCallback(async () => {
        await invalidateReservations();
        dispatch(fetchReservationModuleReduxEntities(scope, { balances: true }));
        // We need to wait until the query switches to load canceled reservations
        await invalidateOrderItems();
    }, [invalidateReservations, invalidateOrderItems, dispatch, scope]);
    const invalidateReservationDataRedux = () =>
        dispatch(fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_ORDER_ITEMS_EXTENT }));
    const refetchGroup = isReservationModuleReactQueryEnabled
        ? invalidateReservationData
        : invalidateReservationDataRedux;

    if (!selectionIsCancellable) {
        return null;
    }
    return <ReservationCancellationFormCardElement {...other} refetchGroup={refetchGroup} />;
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        selectionIsCancellable: selectionIsCancellableSelector,
        reservationIds: getCheckedReservationIds,
    })
)(ReservationCancellationFormCard);
